// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e020ff94","575":"35a5f0f8","744":"2bf4ae94","801":"1963fd9d","981":"afd2d2c9"}[chunkId] + ".chunk.js";
};